import axios from "axios/index";
import { API } from "../utilities/api.config";

// Will produce actions:
//
//   UPDATE_FEES_ADVISOR_RATE_FAIL
//   UPDATE_FEES_ADVISOR_RATE_REQUESTED
//   UPDATE_FEES_ADVISOR_BASE_SUCCESS
//
//   UPDATE_FEES_ADVISOR_RATE_DEFAULT_FAIL
//   UPDATE_FEES_ADVISOR_RATE_DEFAULT_REQUESTED
//   UPDATE_FEES_ADVISOR_RATE_DEFAULT_SUCCESS
//
//   UPDATE_FEES_ADVISOR_RATE_PORTFOLIO_FAIL
//   UPDATE_FEES_ADVISOR_RATE_PORTFOLIO_REQUESTED
//   UPDATE_FEES_ADVISOR_RATE_PORTFOLIO_SUCCESS
//
//   UPDATE_FEES_ADVISOR_CUSTODIAN_FAIL
//   UPDATE_FEES_ADVISOR_CUSTODIAN_REQUESTED
//   UPDATE_FEES_ADVISOR_CUSTODIAN_SUCCESS
//
//   UPDATE_FEES_ADVISOR_PLATFORM_FAIL
//   UPDATE_FEES_ADVISOR_PLATFORM_REQUESTED
//   UPDATE_FEES_ADVISOR_PLATFORM_SUCCESS
//
//   UPDATE_FEES_DEFAULT_CUSTODIAN_FAIL
//   UPDATE_FEES_DEFAULT_CUSTODIAN_REQUESTED
//   UPDATE_FEES_DEFAULT_CUSTODIAN_SUCCESS
//
//   UPDATE_FEES_DEFAULT_PLATFORM_FAIL
//   UPDATE_FEES_DEFAULT_PLATFORM_REQUESTED
//   UPDATE_FEES_DEFAULT_PLATFORM_SUCCESS

function feeRequestHelper(data, key) {
  const request = () =>
    axios.post(API[key], data, {
      headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
    });

  return (dispatch) => {
    dispatch({
      type: `${key}_REQUESTED`,
    });
    request()
      .then((response) => {
        dispatch({
          type: `${key}_SUCCESS`,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: `${key}_FAIL`,
          payload: error,
        });
      });
  };
}

const updateAdvisorRate = function updateAdvisorRate(rate, advisorId) {
  const key = "UPDATE_FEES_ADVISOR_RATE";
  const data = {
    advisorId,
    rate,
  };
  return feeRequestHelper(data, key);
};

const updateAdvisorCustodian = function updateAdvisorCustodian(
  fees,
  advisorId,
  custodianId
) {
  const key = "UPDATE_FEES_ADVISOR_CUSTODIAN";
  const data = {
    advisorId,
    custodianId,
    fees,
  };

  return feeRequestHelper(data, key);
};

const updateAdvisorPlatform = function updateAdvisorPlatform(fees, advisorId) {
  const key = "UPDATE_FEES_ADVISOR_PLATFORM";
  const data = {
    advisorId,
    fees,
  };

  return feeRequestHelper(data, key);
};

const updateDefaultAdvisorRate = function updateDefaultAdvisorRate(rate) {
  const key = "UPDATE_FEES_ADVISOR_RATE_DEFAULT";
  const data = { rate };
  return feeRequestHelper(data, key);
};

const updateDefaultCustodian = function updateDefaultCustodian(
  fees,
  custodianId
) {
  const key = "UPDATE_FEES_DEFAULT_CUSTODIAN";
  const data = {
    custodianId,
    fees,
  };

  return feeRequestHelper(data, key);
};

const removeCustodian = function removeCustodian(advisorId, custodianId) {
  const key = "UPDATE_FEES_CUSTODIAN";
  const data = {
    advisorId,
    custodianId,
  };

  return feeRequestHelper(data, key);
};

const updateDefaultPlatform = function updateDefaultPlatform(
  fees,
  custodianId
) {
  const key = "UPDATE_FEES_DEFAULT_PLATFORM";
  const data = {
    fees,
  };

  return feeRequestHelper(data, key);
};

const updatePortfolioAdvisorRate = function updatePortfolioAdvisorRate(
  rate,
  householdId,
  portfolioId
) {
  const key = "UPDATE_FEES_ADVISOR_RATE_PORTFOLIO";
  const data = {
    rate,
    householdId,
    portfolioId,
  };
  return feeRequestHelper(data, key);
};

export default {
  removeCustodian,
  updateAdvisorCustodian,
  updateAdvisorRate,
  updateAdvisorPlatform,
  updateDefaultAdvisorRate,
  updateDefaultCustodian,
  updateDefaultPlatform,
  updatePortfolioAdvisorRate,
};



// WEBPACK FOOTER //
// ./src/actions/fee.action.js